import type { Components } from '@mui/material/styles';

export default function MUIImageListItemBar(): Components['MuiImageListItemBar'] {
  return {};
}
